export enum Section {
    PendingDonor = 1,
    PendingCenter = 2,
    PendingRecipient = 3,
    PendingAnalysis = 4,
    PendingReview = 5,
    PendingDecision = 6,
    Completed = 7,
    Search = 8
}
